<template>
    <div class="maintenance_box">
        <div style="width: 300px;height: 100%;">
            <div>
                <el-button type="primary" :icon="ArrowLeft" @click="router.back()"
                    style="margin: 10px 10px 10px 0;">{{ t('maintenance.back') }}</el-button>
                <span style="font-size: 20px;">({{ t('maintenance.templateLabel') }}： {{ state.templateInfo.title }})</span>
            </div>
            <div style="width: 100%;display: flex;">
                <div>
                    <el-button style="margin-left: 20px;" type="primary" icon="Plus"
                        @click="$refs['addSpare'].open()">{{ t('maintenance.addPart') }}</el-button>
                </div>
            </div>
            <el-tree ref="tree" style="width: 100%;margin-top: 10px;" :data="state.treeData" :props="defaultProps"
                :default-expand-all="true" highlight-current :node-key="'id'" @node-click="handleNodeClick">
                <template #default="{ node, data }">
                    <div style="width: 100%; display: flex;justify-content: space-between;">
                        <span>{{ node.label }}</span>
                        <el-button :icon="Edit" circle size="small" @click.stop="$refs['addSpare'].open(data)" />
                    </div>
                </template>
            </el-tree>
        </div>
        <div style="width: calc(100% - 325px);height: 100%;display: flex;margin-left: 10px;">
            <div ref="myElementRef" style="width: 100%;height: 100%;margin-left: 10px;">
                <div style="width:120px;">
                    <el-button type="primary" icon="Plus" @click="openAddProject">{{ t('maintenance.addProject') }}</el-button>
                </div>
                <hc-table :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
                    :maxPage="maxPage" :isHidePage="true"
                    @pageChange="pageChange" @limitChange="limitChange">
                    <template #frequencyType="{ row }">
                        {{ listToMap(typeMap)[row.frequencyType] }}
                    </template>
                    <template #status="{ row }">
                        {{ listToMap(statusMap)[row.status] }}
                    </template>
                    <template #operation="scope">
                        <div class="btn_box_det">
                            <el-button class="opBtn" size="small" type="primary" link
                                @click="$refs['addPlan'].open(scope.row)">{{ t('maintenance.edit') }}</el-button>
                        </div>
                    </template>
                </hc-table>
            </div>
        </div>

         <!-- 新增零部件 -->
        <AddSpare ref="addSpare"  :device_id="state.device_id" @refresh="refreshList()" />

         <!-- 新增保养计划 -->
        <AddPlan ref="addPlan"  :device_id="state.device_id" :plans_id="state.nodeData.id" @refresh="refreshList()" />
    </div>
</template>

<script setup>
import { onMounted, reactive, ref, nextTick, defineProps, defineEmits, toRaw } from "vue";
import {
    ArrowLeft, Edit
} from '@element-plus/icons-vue'
import { ElTree } from "element-plus";
import { pageListApi } from "@/api/system/maintenance.js";
import { detailApi as templateDetailApi } from "@/api/system/template.js";
import { ElMessage } from "element-plus";
import { useRoute, useRouter } from 'vue-router';
import hcTable from "@/components/hc-table/index.vue";
import AddSpare from "./components/addSpare.vue";
import AddPlan from "./components/addPlan.vue";
import SubmitRecord from "./submitRecord.vue"
import { listToMap } from "@/utils/utils";
import { t } from "@/locale/index.js";
const route = useRoute();
const router = useRouter();
const myElementRef = ref();
const addSpare = ref();
const addPlan = ref();
const tree = ref();

const defaultProps = reactive({
    // children: 'list',
    label: 'name',
})

const statusMap = reactive([
    {
        label: "停用",
        value: 0
    },
    {
        label: "启用",
        value: 1
    }
])

const typeMap = reactive([

    {
        label: "天数",
        value: 0
    },
    {
        label: "消耗",
        value: 1
    },
    {
        label: "时间 ",
        value: 2
    }
])

const activeName = ref('project')

let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const state = reactive({
    device_id: Number(route.query.id) || 0,
    templateInfo: {},
    keywords: '',
    treeData: [],
    nodeData: {},
    column: [
        {
            prop: "id",
            show: false,
            label: "项目ID",
        },
        {
            // prop: "id",
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "title",
            show: true,
            label: "保养项目",
        },
        {
            prop: "content",
            show: true,
            label: "保养内容",
        },
        {
            prop: "day",
            show: true,
            label: "保养周期 天数",
        },
        {
            prop: "kilometer",
            show: true,
            label: "保养周期 公里",
        },
        {
            prop: "hour",
            show: true,
            label: "保养周期 时间",
        },
        {
            prop: "requiredMaterials",
            show: true,
            label: "所需物料",
        },
        {
            prop: "dose",
            show: true,
            label: "单台用量",
        },
        {
            prop: "frequencyType",
            show: true,
            label: "频率类型",
        },
        {
            prop: "status",
            show: true,
            label: "状态",
        },
        {
            prop: "createdAt",
            show: true,
            label: "创建时间",
        },
        {
            prop: "operation",
            show: true,
            label: "操作",
        },
    ],
    offsetHeight: 0,
    tableHeader: [],
    tableData: [
        {
            "id": 1,
            "title": "主起重钩滑轮组",
            "content": "油枪注射润滑",
            "day": 30,
            "kilometer": 0,
            "requiredMaterials": "润滑脂",
            "dose": null,
            "plansId": 1,
            "frequencyType": 0,
            "status": 1,
            "createdAt": "2025-05-10 16:37:19",
            "updatedAt": "2025-05-10 16:37:35"
        }
    ]
})

const handleClick = (e) => {
}

const getTemplateDetail = () => {
    const params = JSON.stringify({
        "id": state.device_id
    })
    templateDetailApi(params).then(res => {
        state.templateInfo = res?.data?? {}
    })
}



const pageChange = (currentPage) => {
    page.value = currentPage;
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
}

const getTreeData = () => {
    state.treeData = []
    const params = JSON.stringify({
        "page": page.value,
        "limit": limit.value,
        "keywords": state.keywords,
        "device_id": state.device_id
    })
    pageListApi(params).then(res => {
        state.treeData = res?.data ?? [];
        state.tableData = [];
        if(state.treeData.length > 0) {
            tree.value.setCurrentKey(state.nodeData.id ?? state.treeData[0]?.id)
            state.nodeData = toRaw(state.nodeData.id ? state.nodeData : state.treeData[0])
            state.tableData = state.nodeData.list ?? [];
        }
        maxPage.value = res?.maxPage ?? 0;
    })
}

const openAddProject = () => {
    if(!state.nodeData.id) {
        ElMessage.warning('请选择零部件')
        return
    }
    addPlan.value.open()
}

const refreshList = () => {
    page.value = 1
    limit.value = 20
    getTreeData()
}

const handleNodeClick = (data, node, event) => {
    state.nodeData = toRaw(data)
    state.tableData = state.nodeData.list ?? [];
}

onMounted(async () => {
    nextTick(() => {
        offHeighths();
    });
    window.onresize = () => {
        nextTick(() => {
            offHeighths();
        });
    };
    tableHeaderFn();
    getTemplateDetail()
    getTreeData()
})

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 95;
    }
};

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};

</script>

<style lang="scss" scoped>
.maintenance_box {
    /* display: flex; */
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
    width: calc(100% - 10px);
    margin-left: 10px;
    display: flex;
}

.form-wrapper {
    margin-top: 20px;
    width: 70%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}

.el-tabs {
    width: 100%;
}

::v-deep .el-tabs__content {
    .el-tab-pane {
        height: 100%;
    }
}
</style>
